import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { Theme, useMediaQuery } from '@mui/material'
import { LayoutProviderProps } from './LayoutProvider.types'
import { LayoutDrawer, LayoutUser } from './LayoutContext.types'
import { LayoutContext } from './LayoutContext'

function LayoutProvider({ children }: LayoutProviderProps) {
    const mobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))
    const lg = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'))
    const width = useMemo(() => (lg ? 280 : 260), [lg])

    const isOpen = useCallback((): boolean => {
        return localStorage.getItem('ShowDrawer') !== 'false'
    }, [])

    const defineDrawer = useCallback(
        (open: boolean): LayoutDrawer => {
            return { open, width: open ? width : 0 }
        },
        [width]
    )

    const [drawer, setDrawer] = useState<LayoutDrawer>(() => {
        const open = isOpen()
        return defineDrawer(!mobile && open)
    })

    const [user, setUser] = useState<LayoutUser>(() => {
        return {
            blocked: false,
        }
    })

    useEffect(() => {
        const open = isOpen()
        setDrawer(defineDrawer(!mobile && open))
    }, [defineDrawer, isOpen, mobile])

    const toggleDrawer = () => {
        openDrawer(!drawer.open, !mobile)
    }

    const closeDrawer = () => {
        if (mobile && drawer.open) {
            openDrawer(false, false)
        }
    }

    const openDrawer = (open: boolean, write: boolean) => {
        const drawer = defineDrawer(open)
        setDrawer(drawer)

        if (write) {
            localStorage.setItem('ShowDrawer', `${drawer.open}`)
        }
    }

    const blockUser = () => {
        setUser({ ...user, blocked: true })
    }

    return (
        <LayoutContext.Provider
            value={{
                mobile,
                drawer,
                user,
                toggleDrawer,
                openDrawer,
                closeDrawer,
                blockUser,
            }}
        >
            {children}
        </LayoutContext.Provider>
    )
}

export default memo(LayoutProvider)
